export var ORDER_MANAGEMENT_INFO_TESTID = 'ORDER_MANAGEMENT_INFO';
export var TERMS_AND_CONDITIONS_TESTID = 'TERMS_AND_CONDITIONS';
export var CANCEL_BUTTON_TESTID = 'CANCEL_BUTTON';
export var CTA_BUTTON_TESTID = 'CTA_BUTTON'; //
export var BUTTON_CONDITIONS_TESTID = 'BUTTON_CONDITIONS';
export var ORDER_MANAGEMENT_TESTID = 'ORDER_MANAGEMENT';
export var RESUME_FAILED = 'Resume Subscription Failed';
export var RESTART_FAILED = 'Restart Subscription Failed';
export var ActionFailedMessage = /*#__PURE__*/function (ActionFailedMessage) {
  ActionFailedMessage["RESUME"] = "Resume Subscription Failed";
  ActionFailedMessage["UNDOCANCEL"] = "Restart Subscription Failed";
  return ActionFailedMessage;
}({});
export var OMActionType = /*#__PURE__*/function (OMActionType) {
  OMActionType["RESUME"] = "resume";
  OMActionType["UNDOCANCEL"] = "undoCancel";
  return OMActionType;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/OrderManagement/constants.js
// module id = 1528
// module chunks = 11